import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext();
const InvoiceContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) : null;
      });
    
      const [invoiceNumber, setInvoiceNumber] = useState('');
    
      const login = (username, userID, companyID) => {
        const userData = { username, userID, companyID };
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
      };
    
      const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
      };
      
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <InvoiceContext.Provider value={{ invoiceNumber, setInvoiceNumber }}>
        {children}
      </InvoiceContext.Provider>
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export const useInvoice = () => useContext(InvoiceContext);
